import React, { useEffect, useRef } from "react";
import { useToggle } from "react-use";

import { clsxm } from "@/utils/tailwindMerge";

import { useSliderContext } from "../../context/Slider.context";
import { PlayCircleIcon } from "../PlayCircleIcon";

type PropTypes = {
  isSelected: boolean;
  index: number;
  source?: string;
};

export const SliderVideo: React.FC<PropTypes> = ({
  index,
  isSelected,
  source = "",
}) => {
  const [isVideoPlaying, toggleVideoIsPlaying] = useToggle(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const { initialIndex, currentPhotoIndex } = useSliderContext();

  const onVideoToggle = () => {
    if (isVideoPlaying) {
      videoRef.current?.pause();
    } else {
      videoRef.current?.play();
    }

    toggleVideoIsPlaying();
  };

  useEffect(() => {
    const isInitialClickOnVideo =
      videoRef?.current?.dataset.ind === initialIndex.toString();

    if (isInitialClickOnVideo) {
      videoRef.current.play();
    }
  }, [initialIndex]);

  useEffect(() => {
    const isCurrentVideoIndex =
      videoRef?.current?.dataset.ind === currentPhotoIndex.toString();

    if (!isCurrentVideoIndex) {
      videoRef.current?.pause();
    }
  }, [currentPhotoIndex, initialIndex]);

  useEffect(() => {
    const videoNode = videoRef.current;

    const playVideo = () => {
      toggleVideoIsPlaying(true);
    };
    const pauseVideo = () => {
      toggleVideoIsPlaying(false);
    };

    videoNode?.addEventListener("play", playVideo);
    videoNode?.addEventListener("pause", pauseVideo);

    return () => {
      videoNode?.removeEventListener("play", playVideo);
      videoNode?.removeEventListener("pause", pauseVideo);
    };
  }, [toggleVideoIsPlaying]);

  return (
    // {isAnyVideo(obj) && (
    <>
      <video
        controls={isSelected}
        data-ind={index}
        controlsList="nodownload"
        ref={videoRef}
        className="rounded-lg max-h-[90vh] cursor-pointer"
        data-testid={"sliderVideo" + (isSelected ? " current" : "")}
      >
        <source
          // adding #t=0.001 to the end of the source to fix the issue with the first frame not showing on iOS
          type="video/mp4"
          src={source + "#t=0.001"}
        />
      </video>
      {!isVideoPlaying && (
        <PlayCircleIcon
          ignoreNotDisplayingOnMobile={!isSelected}
          className={clsxm(isSelected && "top-1/4 bottom-1/4")}
          onClick={isSelected ? onVideoToggle : undefined}
        />
      )}
    </>
    // )}
  );
};
